export const GET_STUDIOS = "GET_STUDIOS";
export const GET_STUDIO_BY_ID = "GET_STUDIO_BY_ID";
export const UPDATE_STUDIO = "UPDATE_STUDIO";
export const DELETE_STUDIO = "DELETE_STUDIO";
export const CREATE_STUDIO = "CREATE_STUDIO";
export const GET_STUDIO_STUDIO_SESSIONS = "GET_STUDIO_STUDIO_SESSIONS";
export const GET_STUDIO_PROJECTS = "GET_STUDIO_PROJECTS";
